import { Report } from '@mi-front/core';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../../../api';

/**
 * Fetches a report by id. Uses query key ['report', id].
 * When reportId is undefined, the query is disabled.
 */
export function useReportQuery(reportId: string | undefined) {
  return useQuery({
    queryKey: ['report', reportId],
    queryFn: () => apiClient.reports.fetchReport(reportId!) as Promise<Report>,
    enabled: !!reportId,
  });
}
